import { donationPerVehicle, soldVehiclesCount, totalDonated } from '../../../mocks/donationData';
import { Link } from 'react-router-dom';

export default function HowYourPurchaseHelps() {
  const donated = Number.isFinite(totalDonated) ? totalDonated : 0;
  const sold = Number.isFinite(soldVehiclesCount) ? soldVehiclesCount : 0;

  return (
    <section
      className="rounded-2xl overflow-hidden border border-amber-200 shadow-sm"
      aria-labelledby="purchase-helps-heading"
    >
      {/* Header */}
      <div
        className="px-7 py-5 flex items-center gap-3"
        style={{ background: 'linear-gradient(135deg, #1A2332 0%, #2C3E50 100%)' }}
      >
        <div className="w-10 h-10 flex items-center justify-center rounded-full bg-amber-400/20 border border-amber-400/40 flex-shrink-0">
          <i className="ri-heart-fill text-amber-400 text-xl" aria-hidden="true" />
        </div>
        <h2
          id="purchase-helps-heading"
          className="text-xl font-black text-white"
          style={{ fontFamily: "'Oswald', sans-serif", letterSpacing: '0.06em' }}
        >
          HOW YOUR PURCHASE HELPS
        </h2>
      </div>

      {/* Body */}
      <div className="bg-gradient-to-br from-amber-50 via-orange-50 to-amber-50 p-7">
        {/* $100 callout */}
        <div className="flex items-start gap-4 mb-6">
          <div
            className="flex-shrink-0 w-16 h-16 rounded-2xl flex flex-col items-center justify-center shadow-md"
            style={{ background: 'linear-gradient(135deg, #F5C842 0%, #F59E0B 100%)' }}
            aria-hidden="true"
          >
            <span className="text-[10px] font-black text-[#1A1208] uppercase tracking-widest leading-none">$</span>
            <span className="text-2xl font-black text-[#1A1208] leading-none">{donationPerVehicle}</span>
          </div>
          <div>
            <p className="text-base font-bold text-[#1A2332] leading-snug mb-1">
              $100 donated to Oregon Dog Rescue with every vehicle sold
            </p>
            <p className="text-sm text-[#4A5568] leading-relaxed">
              When you buy from Rockhound Auto, we make a{' '}
              <strong className="text-amber-700">${donationPerVehicle} donation on your behalf</strong> to{' '}
              <strong className="text-amber-700">Oregon Dog Rescue</strong>
              — a no-kill shelter serving the greater Portland area.
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-amber-200 mb-5" aria-hidden="true" />

        {/* What the donation does */}
        <p className="text-xs font-black text-[#6B7A8D] uppercase tracking-widest mb-3">What your $100 helps fund</p>
        <ul className="space-y-2.5 mb-6" role="list">
          {[
            { icon: 'ri-stethoscope-line', text: 'Veterinary care & medical treatment for rescued dogs' },
            { icon: 'ri-home-heart-line', text: 'Foster & shelter housing while dogs await adoption' },
            { icon: 'ri-hand-heart-line', text: 'Rehabilitation & training for dogs with difficult pasts' },
            { icon: 'ri-search-heart-line', text: 'Adoption matching to find loving forever homes' },
          ].map((item, i) => (
            <li key={i} className="flex items-start gap-3">
              <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className={`${item.icon} text-amber-500 text-base`} aria-hidden="true" />
              </div>
              <span className="text-sm text-[#4A5568] leading-snug">{item.text}</span>
            </li>
          ))}
        </ul>

        {/* Stats row */}
        {sold > 0 && (
          <div className="grid grid-cols-2 gap-3 mb-5">
            <div className="bg-white/80 rounded-xl p-4 text-center border border-amber-100">
              <p className="text-2xl font-black text-amber-600" style={{ fontFamily: "'Oswald', sans-serif" }}>
                {sold}+
              </p>
              <p className="text-xs text-[#6B7A8D] font-medium mt-0.5">Vehicles Sold</p>
            </div>
            <div className="bg-white/80 rounded-xl p-4 text-center border border-amber-100">
              <p className="text-2xl font-black text-green-600" style={{ fontFamily: "'Oswald', sans-serif" }}>
                ${donated.toLocaleString()}
              </p>
              <p className="text-xs text-[#6B7A8D] font-medium mt-0.5">Total Donated</p>
            </div>
          </div>
        )}

        <Link
          to="/community-impact"
          className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl text-sm font-semibold text-[#1A2332] border border-amber-300 bg-white/70 hover:bg-white transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-heart-3-line text-amber-500" aria-hidden="true" />
          See Our Full Community Impact
        </Link>
      </div>
    </section>
  );
}
